import { MessageSquare } from 'lucide-react'

export function EmptyState() {
  return (
    <div
      className="flex flex-col items-center justify-center h-full text-center p-8"
      style={{ backgroundColor: '#efeae2' }}
    >
      <div className="w-20 h-20 rounded-2xl bg-white shadow-sm flex items-center justify-center mb-5">
        <MessageSquare className="w-8 h-8 text-[#00a884]" />
      </div>
      <h3 className="text-base font-semibold text-[#111b21] mb-1.5">
        WhatsApp Conversations
      </h3>
      <p className="text-sm text-[#667781] max-w-xs leading-relaxed">
        Select a conversation from the list to view messages and reply to patients.
      </p>
    </div>
  )
}
